
























































import { BookmarkItem, BookmarkCard } from '@/types/content'
import WrappedLink from '@components/WrappedLink.vue'
import Card from '@components/BookmarkCard.vue'
import Placeholder from '@components/placeholders/BookmarkCardPlaceholder.vue'
import get from 'lodash/get'
import overlays from '@/mixins/overlays'
import utils from '@/mixins/utils'
import wrappers from '@/mixins/wrappers'
import mixins from 'vue-typed-mixins'
import eventTracker from '@/utils/eventTracker'

export default mixins(utils, overlays, wrappers).extend({
  name: 'LearningBookmarks',
  components: {
    Card,
    Placeholder,
    WrappedLink
  },
  mounted () {
    eventTracker.track('Learn Bookmark', {})
  },
  computed: {
    wrapped (): Record<string, any> {
      return {
        removeBookmark: this.offlineWrapper(this.removeBookmark)
      }
    },
    bookmarks (): BookmarkCard[] {
      return this.$store.getters['user/content/bookmarks'].map(
        (bookmarkItem: BookmarkItem) => {
          const category = get(bookmarkItem, 'cmsContent.category', '')
          const title = get(bookmarkItem, 'cmsContent.title', '')
          const description = this.contentBodyToText(get(bookmarkItem, 'cmsContent.body'))
          const imageUrl = get(bookmarkItem, 'cmsContent.imgUrl') || 'https://via.placeholder.com/200'
          const contentId = get(bookmarkItem, 'cmsContent.id')
          return {
            category, title, description, imageUrl, contentId
          }
        }
      )
    }
  },
  methods: {
    async cardClicked ({ contentId, title: contentTitle }: BookmarkCard) {
      eventTracker.track('LearnBookMark contentChosen', { contentId, contentTitle })
    },
    async removeBookmark ({ contentId, title }: BookmarkCard) {
      try {
        const bookmarkRemoved = await this.$store.dispatch(
          'user/content/UpdateBookmark', {
            contentId,
            value: false,
            undo: this.showSnackbar(this.$t('snackbars.articleRemoved'), {
              showUndo: true
            })
          })
        if (bookmarkRemoved) {
          eventTracker.track('LearnBookMark Bookmark', {
            contentId,
            bookmark: 0,
            contentTitle: title
          })
        }
      }
      finally {
        // NOP
      }
    }
  }
})
